module.exports = __webpack_public_path__ + "static/media/window-maximize.e3d93cde.svg";